export default "__VITE_ASSET__R66AbjKA__"